<!-- Json Viewe Juan funcional sin números al lado izquierdo -->
<div *ngIf="typeview == 'json-cap'" class="w-full bg-[#393b3f] text-white p-4 rounded-lg rounded-l-none h-auto max-h-[500px] overflow-auto">
    <pre><div>{{code | json}}</div></pre>
</div>

<!-- Ace Editor -->
<!-- Lo malo de que sea un componente es que es estático -->
<div *ngIf="typeview == 'ace-editor'" class="w-full bg-[#141414] py-4 text-white h-[500px]">
    <div
        class="app-ace-editor"
        #editor
        style="width: 100%;height: 100%;"
    ></div>
</div>